"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTextField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const FilterTextField = ({ placeholder, maxLength, value, onChange, }) => {
    const [filterFieldState, setFilterFieldState] = React.useState({
        prevPropsValue: value,
        value: value || '',
    });
    React.useEffect(() => {
        setFilterFieldState(() => {
            if (value !== filterFieldState.prevPropsValue) {
                return {
                    prevPropsValue: value,
                    value: value,
                };
            }
            return null;
        });
    }, [value, filterFieldState.prevPropsValue]);
    const handleSendData = React.useCallback((value) => {
        if (onChange) {
            onChange(value);
        }
    }, [onChange]);
    const handleKeyPress = React.useCallback((event) => {
        if (event.key === 'Enter') {
            handleSendData(filterFieldState.value);
        }
        return false;
    }, [filterFieldState.value, handleSendData]);
    const handleOnBlur = React.useCallback(() => {
        handleSendData(filterFieldState.value);
        return false;
    }, [filterFieldState.value, handleSendData]);
    const handleChange = React.useCallback((event) => {
        setFilterFieldState(current => (Object.assign(Object.assign({}, current), { value: event.target.value })));
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "filter-textfield", children: (0, jsx_runtime_1.jsx)("input", { className: "filter-textfield__field", value: filterFieldState.value, onKeyPress: handleKeyPress, onChange: handleChange, onBlur: handleOnBlur, placeholder: placeholder, maxLength: maxLength || null }) }));
};
exports.FilterTextField = FilterTextField;
